import EmptyTable from "./EmptyTable";

export default EmptyTable;
